export default __webpack_public_path__ + "static/media/photo--lg--ken-1.1524733a.jpg";